import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import css from './TicketCount.module.scss';

interface Props {
  count: number;
}

const TicketCount = (props: Props) => {
  const intl = useIntl();
  return (
    <span className={classNames(css.TicketCount)}>
      <span className={css.TicketCount__Emphasis}>{props.count}</span>
      {intl.formatMessage({ id: 'merchants.common.ticketCount.unit' })}
    </span>
  );
};

export default TicketCount;
